var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMayor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 0.875H2.125C1.79348 0.875 1.47554 1.0067 1.24112 1.24112C1.0067 1.47554 0.875 1.79348 0.875 2.125V10.875C0.875 11.2065 1.0067 11.5245 1.24112 11.7589C1.47554 11.9933 1.79348 12.125 2.125 12.125H10.875C11.5688 12.125 12.125 11.5688 12.125 10.875V2.125C12.125 1.79348 11.9933 1.47554 11.7589 1.24112C11.5245 1.0067 11.2065 0.875 10.875 0.875ZM9.36875 8.81875L6.5 5.95L3.63125 8.81875L2.75 7.93125L6.5 4.18125L10.25 7.93125L9.36875 8.81875Z",
    fill: "#E4FD3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMayor);
export default __webpack_public_path__ + "static/media/mayor.f079d9d8c5efcf47b09e48d9d45a4c41.svg";
export { ForwardRef as ReactComponent };